import { useContext, useState } from "react";
import { arrow_stroke, profileIcon, signOutIcon } from "../../../assets/icons";
import styles from "./profileButton.module.css";
import { Link, useNavigate } from "react-router-dom";
import { AccountContext } from "../../../Store/Account.store";
import { signOutUser } from "../../../Api/Services/Account";

interface Props {
  isInMenu?: boolean;
  greenText?: boolean;
}

export default function ProfileButton({ isInMenu, greenText }: Props) {
  const {setAccountData} = useContext(AccountContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const {accountData} = useContext(AccountContext);

  const signOut = () => {
    signOutUser().then(() => {
      setAccountData({isauthenticated: false, username: "", roles: []});
      localStorage.removeItem("user");
      navigate("/");
    });
  }
  const toggleOpen = () => {
    setOpen(!open);
  }

  return (
    <div className={`${styles.profile_container} ${isInMenu ? styles.menu_account : ""}`}>
      <button type="button" className={`${styles.signInButton} ${greenText ? styles.green_text : ''} ${open ? styles.open: ""} ${isInMenu == true ? styles.in_menu : ""}`} onClick={toggleOpen} aria-controls={styles.profileWindow} aria-expanded={open ? "true": "false"}><i className={styles.profile_icon}>{profileIcon}</i> My profile <i className={styles.arrow_icon}>{arrow_stroke}</i></button>
      {open && 
        <div id={styles.profileWindow}>
            <span>My Profile</span>
            {accountData.roles.includes("Administrator") && <Link onClick={toggleOpen} to="/not-published">All not published</Link>}
            <Link onClick={toggleOpen} to="/my-ads">See my ads</Link>
            <Link onClick={toggleOpen} to="/profile">Edit profile</Link>
            <button className={`${styles.sign_out} button`} onClick={signOut}><i>{signOutIcon}</i> Sign out</button>
        </div>
      }
    </div>
  );
}
